import { classNames } from "primereact/utils";
import { getStarLabel } from "../../utils/reviewUtility";
import styles from "./StarRating.module.scss";

const STARS = [1, 2, 3, 4, 5];

/** How much of a star to colour, 0–100 %: an average of 4.3 fills the fifth star by 30 %. */
export const getStarFillPercent = (value: number, star: number) =>
  Math.round(Math.min(Math.max(value - (star - 1), 0), 1) * 100);

interface IStarRatingProps {
  value: number;
  /** When given, the stars become five buttons that pick the rating. */
  onChange?: (rating: number) => void;
  size?: "small" | "medium" | "large";
  className?: string;
}

export const StarRating = ({
  value,
  onChange,
  size = "small",
  className,
}: IStarRatingProps) => {
  if (!onChange) {
    return (
      <span
        role="img"
        aria-label={`Оценка ${value} от 5`}
        className={classNames(styles.root, styles[size], className)}
      >
        {STARS.map((star) => {
          const fill = getStarFillPercent(value, star);
          return (
            <span
              key={star}
              aria-hidden="true"
              className={classNames(styles.star, styles.partial, {
                [styles.filled]: fill === 100,
              })}
            >
              ★
              {fill > 0 && fill < 100 && (
                <span className={styles.partial_fill} style={{ width: `${fill}%` }}>
                  ★
                </span>
              )}
            </span>
          );
        })}
      </span>
    );
  }

  return (
    <div className={classNames(styles.root, styles[size], className)}>
      {STARS.map((star) => (
        <button
          key={star}
          type="button"
          aria-label={getStarLabel(star)}
          aria-pressed={star <= value}
          className={classNames(styles.star, styles.button, {
            [styles.filled]: star <= value,
          })}
          onClick={() => onChange(star)}
        >
          ★
        </button>
      ))}
    </div>
  );
};
